import React, { useMemo } from 'react';
import classNames from 'classnames';
import ReportDetails from 'components/ReportDetails';
import { useTranslation } from 'react-i18next';
import { REPORT_ACTION_ICONS, REPORT_ACTION_TRANSLATION } from './data';
import { DataRoomShareableLinkReport } from 'models/ShareableLink';
import { getUserFullName } from 'utils';

import './ViewerReportLog.styles.scss';

type ViewerReportLogProps = {
  className?: string;
  report: DataRoomShareableLinkReport;
};

const ViewerReportLog: React.FC<ViewerReportLogProps> = (props) => {
  const { className, report } = props;

  const { action, dataRoomShareableLinkConsumer, dataRoomNode, createdAt } =
    report;

  const { firstName, lastName, email } = dataRoomShareableLinkConsumer;

  const classes = classNames('viewer-report-log', className);

  const { t } = useTranslation();

  const memberName = useMemo(
    () => getUserFullName(firstName, lastName),
    [firstName, lastName],
  );

  const contentText = useMemo(
    () =>
      t(REPORT_ACTION_TRANSLATION[action], {
        email,
        memberName,
        documentName: dataRoomNode?.name,
      }),
    [t, action, email, memberName, dataRoomNode?.name],
  );

  return (
    <ReportDetails
      className={classes}
      text={contentText}
      createdAt={createdAt}
      icon={REPORT_ACTION_ICONS[action]}
    />
  );
};

export default ViewerReportLog;
